import AppBar from '@material-ui/core/AppBar'
import Grid from '@material-ui/core/Grid'
import MuiTabs from '@material-ui/core/Tabs'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { makeStyles, useTheme } from '@material-ui/styles'
import clsx from 'clsx'
import React, { ReactNode, useEffect, useState } from 'react'

import { Theme } from '../../lib/theming/Theme'
import Tab, { TabProps } from './Tab'

const useStyles = makeStyles<Theme>(theme => ({
  appBar: {
    background: theme.palette.common.white,
  },
  tabBar: {
    alignItems: 'center',
    background: theme.palette.common.white,
  },
  tabBarAssignment: {
    justifyContent: 'flex-start',
  },
  tabContainer: {
    justifyContent: 'center',
  },
  tabsIndicator: {
    backgroundColor: theme.palette.secondary.main,
    height: '4px',
  },
}))

export type StoreSalesTabProps = {
  activeTabIndex?: number | null
  children?: ReactNode
  onChange?: (i?: number, url?: string) => void
  tabs: TabProps[]
  version?: string | null
}

const StoreSalesTab = ({
  children,
  tabs,
  activeTabIndex,
  version,
  onChange,
}: StoreSalesTabProps) => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState<number>(0)
  const theme = useTheme<Theme>()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    setActiveTab(activeTabIndex || 0)
  }, [activeTabIndex])

  return (
    <AppBar className={classes.appBar} position="static">
      <Grid container className={classes.tabContainer} wrap="nowrap">
        <MuiTabs
          aria-label="tabs"
          centered={!isMobile || version !== 'assignment'}
          classes={{
            flexContainer: classes.tabsContainer,
            indicator: classes.tabsIndicator,
            root:
              version === 'assignment'
                ? clsx(classes.tabBar, classes.tabBarAssignment)
                : classes.tabBar,
          }}
          scrollButtons="off"
          value={activeTab}
          variant={isMobile ? 'scrollable' : 'standard'}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.url}
              active={activeTabIndex === index}
              index={index}
              label={tab.label}
              page={tab.page}
              target={tab.target}
              url={tab.url}
              version={version}
              onClick={onChange ? (i, url) => onChange(i, url) : undefined}
            />
          ))}
        </MuiTabs>
        {children}
      </Grid>
    </AppBar>
  )
}

export default StoreSalesTab
